import { Type } from './type';

export interface FundInsuranceType {
  fundId?: number;
  type?: Type;
  typeId?: number;
}
